import React, { FC } from "react";

export interface BgGlassmorphismProps {
  className?: string;
}

const BgGlassmorphism: FC<BgGlassmorphismProps> = ({
  className = `
    pointer-events-none
    absolute
    inset-x-0
    md:top-10
    xl:top-40
    min-h-0
    px-20
    py-24
    flex
    justify-center
    overflow-hidden
    z-0
  `,
}) => {
  return (
    <div
      className={`nc-BgGlassmorphism ${className}`}
      data-nc-id="BgGlassmorphism"
    >
      {/* Halo ivoire chaud à gauche */}
      <span
        className="
          block
          h-72
          w-72
          -ml-32
          rounded-full
          bg-[#DDD5C8]
          opacity-[0.10]
          blur-3xl

          lg:h-[34rem]
          lg:w-[34rem]

          dark:bg-slate-500
          dark:opacity-[0.04]
        "
      />

      {/* Halo gris perle au centre */}
      <span
        className="
          block
          mt-12
          h-72
          w-72
          -ml-24
          rounded-full
          bg-[#D9DDE2]
          opacity-[0.09]
          blur-3xl

          lg:h-[34rem]
          lg:w-[34rem]

          dark:bg-slate-400
          dark:opacity-[0.035]
        "
      />

      {/* Halo froid très discret à droite */}
      <span
        className="
          block
          mt-32
          h-72
          w-72
          -ml-16
          rounded-full
          bg-[#CBD5E1]
          opacity-[0.07]
          blur-3xl

          lg:h-96
          lg:w-96

          dark:bg-slate-600
          dark:opacity-[0.03]

          nc-animation-delay-2000
        "
      />
    </div>
  );
};

export default BgGlassmorphism;